'use client';

import React from 'react';

import config from 'configs/app';
import ChartsWidgetsList from 'src/components/stats/ChartsWidgetsList';
import NumberWidgetsList from 'src/components/stats/NumberWidgetsList';
import StatsFilters from 'src/components/stats/StatsFilters';
import useStats from 'src/hooks/useStats';

import styles from './StatsPage.module.css';

const StatsPage: React.FC = () => {
  const {
    isPlaceholderData,
    isError,
    sections,
    currentSection,
    handleSectionChange,
    interval,
    handleIntervalChange,
    handleFilterChange,
    displayedCharts,
    filterQuery,
    initialFilterQuery,
  } = useStats();

  return (
    <div className={ styles.container }>
      <h1 className={ styles.pageTitle }>{ config.chain.name } statistic &amp; data</h1>

      <div className={ styles.section }>
        <NumberWidgetsList/>
      </div>

      <div className={ styles.section }>
        <StatsFilters
          isLoading={ isPlaceholderData }
          initialFilterValue={ initialFilterQuery }
          sections={ sections }
          currentSection={ currentSection }
          onSectionChange={ handleSectionChange }
          interval={ interval }
          onIntervalChange={ handleIntervalChange }
          onFilterInputChange={ handleFilterChange }
        />
      </div>

      <div className={ styles.chartsSection }>
        <ChartsWidgetsList
          filterQuery={ filterQuery }
          initialFilterQuery={ initialFilterQuery }
          isError={ isError }
          isPlaceholderData={ isPlaceholderData }
          charts={ displayedCharts }
          interval={ interval }
        />
      </div>
    </div>
  );
};

export default StatsPage;
